import React from 'react';
import { Button, Typography, Grid, Stack, Autocomplete, FormControlLabel, Switch, InputAdornment, IconButton } from '@mui/material';
import { useFormik, Form, FormikProvider } from 'formik';
import * as Yup from 'yup';
import { createVendorWatcher } from '../../../../redux/actionCreators/admin/vendorManagement';
import { useDispatch, useSelector } from 'react-redux'
import CssTextField from '../../../overrides/longSearchField';
// import BlackButton from '../../../overrides/blackButton'
import CloseButton from '../../../overrides/closeButton';
import { Visibility, VisibilityOff } from '@mui/icons-material';

function VendorCreation(props) {
    const dispatch = useDispatch()

    const { setOpen, status } = props;

    const { ProfileReducers: { loginState }, EmployeeReducers: { divisionList }, UserHomeReducers: { cafeteriaId }, VendorReducers: { getPaymentGateway } } = useSelector(state => state)
    const nUserID = loginState[0]?.nID || 0
    const [showSecret, setShowSecret] = React.useState(false);


    const VendorSchema = Yup.object().shape({
        divisionId: Yup.string().required('Division Id is required'),

        gateway_allowed: Yup.boolean(),

        gateway_id: Yup.number()
            .nullable()
            .transform((value, originalValue) =>
                originalValue === '' || originalValue === null ? null : value
            )
            .when('gateway_allowed', {
                is: true,
                then: schema => schema.required('Payment Gateway is required'),
            }),


        payment_key: Yup.string().when('gateway_allowed', {
            is: true,
            then: schema => schema.required('Payment Key is required'),
            otherwise: schema => schema.notRequired()
        }),

        payment_secret: Yup.string().when('gateway_allowed', {
            is: true,
            then: schema => schema.required('Payment Secret is required'),
            otherwise: schema => schema.notRequired()
        }),

        vendorId: Yup.string().required('Vendor Id is required'),
        vendorName: Yup.string().required('Vendor Name is required'),
        vendorAddress: Yup.string().required('Vendor address is required'),
        mobileNumber: Yup.string().required('Mobile Number is required'),
        emailId: Yup.string().email().required('Email Id is required'),
    });


    const formik = useFormik({
        initialValues: {
            vendorId: '',
            vendorName: '',
            vendorDesc: '',
            vendorAddress: '',
            landLineNumber: '',
            mobileNumber: '',
            emailId: '',
            divisionId: '',
            gateway_id: null,
            gateway_allowed: false,
            payment_key: '',
            payment_secret: ''
        },

        validationSchema: VendorSchema,

        onSubmit: () => {
            const { vendorId, vendorName, vendorDesc, vendorAddress, landLineNumber, mobileNumber, emailId, divisionId, gateway_id, gateway_allowed, payment_key, payment_secret } = formik.values
            let data = {
                "ACTION": "INSERT",
                "CVENDORID": vendorId,
                "CVENDORNAME": vendorName,
                "CVENDORADDRESS": vendorAddress,
                "CLANDLINENUMBER": landLineNumber,
                "CMOBILENUMBER": mobileNumber,
                "CEMAILID": emailId,
                "CVENDORDESC": vendorDesc,
                "NUSERID": nUserID,
                "NDIVISIONID": String(divisionId),
                "SDIVISIONID": cafeteriaId,
                "GATEWAY_ALLOWED": gateway_allowed,
                "GATEWAY_ID": gateway_allowed ? gateway_id : null,
                "PAYMENT_KEY": gateway_allowed ? payment_key : null,
                "PAYMENT_SECRET": gateway_allowed ? payment_secret : null


            }
            dispatch(createVendorWatcher(data, setOpen))
        }
    });

    const { errors, touched, handleSubmit, getFieldProps, setFieldValue } = formik;

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <>
            <FormikProvider value={formik}>
                <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
                    <Typography variant='h5'
                        align='left'
                        style={{ paddingBottom: '10px' }}>
                        {status === 'edit' ? 'Edit Vendor' : 'Vendor Creation'}
                    </Typography>

                    <Grid
                        container
                        style={{ paddingTop: '10px' }}
                        spacing={3}
                        direction='row'
                    >

                        <Grid
                            lg={3}
                            md={4}
                            sm={6}
                            xs={12}
                            item={true}
                        >
                            <Autocomplete
                                id="combo-box-demo"
                                name="divisionId"
                                fullWidth
                                options={divisionList}
                                size="medium"
                                autoHighlight
                                onChange={(event, value) => {
                                    setFieldValue("divisionId", value.id);
                                }}
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) => <CssTextField {...params}
                                    label="Division"
                                    name='divisionId'
                                    required={true}
                                    error={Boolean(touched.divisionId && errors.divisionId)}
                                    helperText={touched.divisionId && errors.divisionId}
                                />}
                            />
                        </Grid>

                        <Grid
                            lg={3}
                            md={4}
                            sm={6}
                            xs={12}
                            item={true}
                        >
                            <CssTextField
                                required={true}
                                style={{}}
                                fullWidth={true}
                                placeholder='vendor Id'
                                label='Vendor Id'
                                name='vendorId'
                                color='primary'
                                type='text'
                                variant='outlined'
                                autoComplete="off"
                                {...getFieldProps("vendorId")}
                                error={Boolean(touched.vendorId && errors.vendorId)}
                                helperText={touched.vendorId && errors.vendorId}
                            />
                        </Grid>
                        <Grid
                            lg={3}
                            md={4}
                            sm={6}
                            xs={12}
                            item={true}
                        >
                            <CssTextField
                                required={true}
                                style={{}}
                                fullWidth={true}
                                placeholder='vendor Name'
                                label='Vendor Name'
                                name='vendorName'
                                color='primary'
                                type='text'
                                variant='outlined'
                                {...getFieldProps("vendorName")}
                                error={Boolean(touched.vendorName && errors.vendorName)}
                                helperText={touched.vendorName && errors.vendorName}
                            />
                        </Grid>

                        <Grid
                            lg={3}
                            md={4}
                            sm={6}
                            xs={12}
                            item={true}
                        >
                            <CssTextField
                                // required={true}
                                style={{}}
                                fullWidth={true}
                                placeholder='vendor Description'
                                label='Vendor Description'
                                name='vendorDesc'
                                color='primary'
                                type='text'
                                variant='outlined'
                                {...getFieldProps("vendorDesc")}
                                error={Boolean(touched.vendorDesc && errors.vendorDesc)}
                                helperText={touched.vendorDesc && errors.vendorDesc}
                            />
                        </Grid>

                        <Grid
                            lg={3}
                            md={4}
                            sm={6}
                            xs={12}
                            item={true}
                        >
                            <CssTextField
                                required={true}
                                style={{}}
                                fullWidth={true}
                                placeholder='vendor Address'
                                label='Vendor Address'
                                name='vendorAddress'
                                color='primary'
                                type='text'
                                variant='outlined'
                                {...getFieldProps("vendorAddress")}
                                error={Boolean(touched.vendorAddress && errors.vendorAddress)}
                                helperText={touched.vendorAddress && errors.vendorAddress}
                            />
                        </Grid>
                        <Grid
                            lg={3}
                            md={4}
                            sm={6}
                            xs={12}
                            item={true}
                        >
                            <CssTextField
                                // required={true}
                                style={{}}
                                fullWidth={true}
                                placeholder='Land Line Number'
                                label='Land Line Number'
                                name='landLineNumber'
                                color='primary'
                                type='text'
                                variant='outlined'
                                {...getFieldProps("landLineNumber")}
                            // error={Boolean(touched.landLineNumber && errors.landLineNumber)}
                            // helperText={touched.landLineNumber && errors.landLineNumber}
                            />
                        </Grid>
                        <Grid
                            lg={3}
                            md={4}
                            sm={6}
                            xs={12}
                            item={true}
                        >
                            <CssTextField
                                required={true}
                                style={{}}
                                fullWidth={true}
                                placeholder='Mobile Number'
                                label='Mobile Number'
                                name='mobileNumber'
                                color='primary'
                                type='text'
                                variant='outlined'
                                {...getFieldProps("mobileNumber")}
                                error={Boolean(touched.mobileNumber && errors.mobileNumber)}
                                helperText={touched.mobileNumber && errors.mobileNumber}
                            />
                        </Grid>

                        <Grid
                            lg={3}
                            md={4}
                            sm={6}
                            xs={12}
                            item={true}
                        >
                            <CssTextField
                                required={true}
                                style={{}}
                                fullWidth={true}
                                placeholder='Email Id'
                                label='Email Id'
                                name='emailId'
                                color='primary'
                                type='text'
                                variant='outlined'
                                {...getFieldProps("emailId")}
                                error={Boolean(touched.emailId && errors.emailId)}
                                helperText={touched.emailId && errors.emailId}
                            />
                        </Grid>
                        <Grid lg={3} md={4} sm={6} xs={12} item>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={formik.values.gateway_allowed}
                                        onChange={(e) => {
                                            const checked = e.target.checked;

                                            setFieldValue('gateway_allowed', checked);

                                            if (!checked) {
                                                setFieldValue('gateway_id', null);
                                                setFieldValue('payment_key', '');
                                                setFieldValue('payment_secret', '');

                                                formik.setFieldTouched('gateway_id', false);
                                                formik.setFieldTouched('payment_key', false);
                                                formik.setFieldTouched('payment_secret', false);
                                            }
                                        }}
                                        color="success"
                                    />

                                }
                                label={formik.values.gateway_allowed ? 'Payment Enabled' : 'Payment Disabled'}
                            />
                        </Grid>


                        <Grid lg={3} md={4} sm={6} xs={12} item>
                            <Autocomplete
                                disabled={!formik.values.gateway_allowed}
                                options={getPaymentGateway || []}
                                getOptionLabel={(option) => option.gateway_name}
                                onChange={(e, value) => {
                                    setFieldValue(
                                        'gateway_id',
                                        value ? Number(value.gateway_id) : null
                                    );
                                }}

                                renderInput={(params) => (
                                    <CssTextField
                                        {...params}
                                        label="Payment Gateway"
                                        required={formik.values.gateway_allowed}
                                        error={
                                            formik.values.gateway_allowed &&
                                            Boolean(touched.gateway_id && errors.gateway_id)
                                        }
                                        helperText={
                                            formik.values.gateway_allowed &&
                                            touched.gateway_id &&
                                            errors.gateway_id
                                        }

                                    />
                                )}
                            />
                        </Grid>

                        {formik.values.gateway_allowed && (
                            <>
                                <Grid lg={3} md={4} sm={6} xs={12} item>
                                    <CssTextField
                                        fullWidth
                                        label="Payment Key"
                                        name="payment_key"
                                        required
                                        {...getFieldProps('payment_key')}
                                        error={Boolean(touched.payment_key && errors.payment_key)}
                                        helperText={touched.payment_key && errors.payment_key}
                                    />
                                </Grid>

                                <Grid lg={3} md={4} sm={6} xs={12} item>
                                    <CssTextField
                                        fullWidth
                                        label="Payment Secret"
                                        name="payment_secret"
                                        required
                                        type={showSecret ? 'text' : 'password'}
                                        autoComplete="new-password"
                                        {...getFieldProps('payment_secret')}
                                        error={Boolean(touched.payment_secret && errors.payment_secret)}
                                        helperText={touched.payment_secret && errors.payment_secret}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => setShowSecret(!showSecret)}
                                                        edge="end"
                                                    >
                                                        {showSecret ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                            </>
                        )}





                        <Grid
                            xs={12}
                            item={true}
                        >
                            <Stack spacing={2} direction='row' justifyContent='end' >
                                <CloseButton onClick={() => handleClose()}
                                    sx={{
                                        //width: '120px',
                                        height: '42px',
                                        left: '0px',
                                        top: '0px',
                                        minWidth: '120px',
                                        marginTop: 'auto',
                                    }}
                                    variant='contained'
                                    size='medium'
                                    type='button'>
                                    <Typography variant='t14_400' color='common.black'>Cancel</Typography>
                                </CloseButton>
                                <Button onClick={handleSubmit}
                                    style={{
                                        //width: '120px',
                                        height: '42px',
                                        left: '0px',
                                        top: '0px',
                                        minWidth: '120px',
                                        backgroundColor: 'common.Bblack',
                                        marginTop: 'auto'
                                    }}
                                    variant='contained'
                                    size='medium'
                                    type='submit'
                                >
                                    <Typography variant='t14_400' color='grey.0'>Submit</Typography>
                                </Button>
                            </Stack>

                        </Grid>
                    </Grid>

                </Form>
            </FormikProvider>
        </>
    );

}

export default VendorCreation;